import { Project } from '@nexxt/common/types';
import * as classnames from 'classnames';
import * as React from 'react';
import IncidenceRate from './IncidenceRate';
import RequestQuote from './RequestQuote';

interface CustomPriceProps {
    // currentProject: Project;
    toggleIncidenceRateModal?: boolean;
    incidenceRate?: string;
    project?: Project;
    notFeasible?: boolean;
    updatePrice: (data: any) => Promise<any>;
    forceOpenCheckout?: () => void;
    onClose: () => void;

    // changePath: (path: string) => void;
}

const CustomPrice: React.FunctionComponent<CustomPriceProps> = (
    props: CustomPriceProps
) => {
    const [customMode, setCustomMode] = React.useState(
        props.toggleIncidenceRateModal ? 'INCIDENCE' : ''
    );
    const clearCustomMode = () => {
        setCustomMode('');
    };
    if (customMode === 'INCIDENCE') {
        return (
            <IncidenceRate
                onBack={clearCustomMode}
                onClose={props.onClose}
                updatePrice={props.updatePrice}
                incidenceRate={props.incidenceRate}
            />
        );
    }

    if (customMode === 'QUOTE') {
        return (
            <RequestQuote
                onBack={clearCustomMode}
                onClose={props.onClose}
                updatePrice={props.updatePrice}
            />
        );
    }

    if (props.notFeasible) {
        const priceDetails = props.project.panelSettings.dynata.price;

        return (
            <React.Fragment>
                <p className="price--modal--title">Not Feasible</p>
                <p className="price--modal--subtitle">
                    We can only guarentee {priceDetails.promisedCount} out of{' '}
                    {props.project.totalSampleSize} respondents that you are
                    looking for. If you would like to go ahead with{' '}
                    {priceDetails.promisedCount} respondents,{' '}
                    <span onClick={props.forceOpenCheckout}>
                        click here to proceed with checkout
                    </span>
                    . Or, close this window and adjust your audience
                    requirements. Otherwise, you can contact us to make use of
                    our research-assisted services, and we can provide a custom
                    quote for {props.project.totalSampleSize} respondents.
                </p>
                <div
                    className={classnames('price--modal--custom-button', {
                        disabled: !props.incidenceRate
                    })}
                    onClick={() => setCustomMode('INCIDENCE')}
                >
                    <p className="price--modal--custom-button-title">
                        Edit the Incidence Rate
                    </p>
                    <p className="price--modal--custom-button-body">
                        If you would like to adjust your estimate and
                        re-calculate the feasibility, click here.
                    </p>
                </div>
                <div
                    className="price--modal--custom-button"
                    onClick={() => setCustomMode('QUOTE')}
                >
                    <p className="price--modal--custom-button-title">
                        Contact Us
                    </p>
                    <p className="price--modal--custom-button-body">
                        Let one of our researchers assist you in sourcing your
                        audience.
                    </p>
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <p className="price--modal--title">Custom Pricing</p>
            <p className="price--modal--subtitle">
                You have implemented custom screeners into your project- this
                means pricing will vary. There are two ways to determine custom
                pricing:
            </p>
            <div
                className="price--modal--custom-button"
                onClick={() => setCustomMode('INCIDENCE')}
                data-test="set-incidence-rate"
            >
                <p className="price--modal--custom-button-title">
                    Provide the Incidence Rate
                </p>
                <p className="price--modal--custom-button-body">
                    If you know the incidence rate, we will be able to provide
                    you with an estimate.
                </p>
            </div>
            <div
                className="price--modal--custom-button"
                onClick={() => setCustomMode('QUOTE')}
            >
                <p className="price--modal--custom-button-title">
                    Request a quote
                </p>
                <p className="price--modal--custom-button-body">
                    We will review your project and provide you with a quote
                    within 24 hours.
                </p>
            </div>
        </React.Fragment>
    );
};

export default CustomPrice;
